export const Required = value => (value ? undefined : 'Required');
export const SilentRequired = value => (value ? undefined : '');



// WEBPACK FOOTER //
// ./src/utils/validators/index.js